'use strict';

export { default as FileListFactory } from './fileList.factory';